import React from 'react';
import proptypes from 'prop-types';
const { bool } = proptypes;
import { FulfillmentPlaceholderStencil } from './FulfillmentPlaceholderStencil';

const FulfillmentPlaceholder = ({ isMajorAppliances }) => {

  return <FulfillmentPlaceholderStencil isMajorAppliances={isMajorAppliances} />;

};

FulfillmentPlaceholder.propTypes = {
  isMajorAppliances: bool
};

FulfillmentPlaceholder.defaultProps = {
  isMajorAppliances: false
};

export { FulfillmentPlaceholder };
